export default "__VITE_ASSET__CqVSqk5o__"